module.exports = unmuteIosAudio;

const USER_ACTIVATION_EVENTS = [
  "auxclick",
  "click",
  "contextmenu",
  "dblclick",
  "keydown",
  "keyup",
  "mousedown",
  "mouseup",
  "touchend",
  "dragend",
];

let _audio;
let _isCreatingAudio = false;

function unmuteIosAudio() {
  const AudioContext = window.AudioContext || window.webkitAudioContext;

  // To detect iOS, check for touch device and confirm Safari-only
  // webkitAudioContext is present.
  const isIos = navigator.maxTouchPoints > 0 && AudioContext != null;

  if (!isIos) return;

  // state can be 'blocked', 'pending', 'allowed'
  // let htmlAudioState = "blocked";
  // let webAudioState = "blocked";

  // let context;
  // let source;

  const sampleRate = new AudioContext().sampleRate;
  const silentAudioFile = createSilentAudioFile(sampleRate);

  USER_ACTIVATION_EVENTS.forEach((eventName) => {
    window.addEventListener(eventName, handleUserActivation, {
      capture: true,
      passive: true,
    });
  });

  // Return a seven samples long 8 bit mono WAVE file
  function createSilentAudioFile(sampleRate) {
    const arrayBuffer = new ArrayBuffer(10);
    const dataView = new DataView(arrayBuffer);

    dataView.setUint32(0, sampleRate, true);
    dataView.setUint32(4, sampleRate, true);
    dataView.setUint16(8, 1, true);

    const missingCharacters = window
      .btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)))
      .slice(0, 13);

    return `data:audio/wav;base64,UklGRisAAABXQVZFZm10IBAAAAABAAEA${missingCharacters}AgAZGF0YQcAAACAgICAgICAAAA=`;
  }

  function handleUserActivation(e) {
    if (_isCreatingAudio) return;
    createHtmlAudio();
    // if (webAudioState === "blocked") {
    //   console.log("create webAudioState");
    //   webAudioState = "pending";
    //   createWebAudio();
    // }
  }

  function createHtmlAudio() {
    _isCreatingAudio = true;

    if (!_audio) {
      _audio = document.createElement("audio");
      _audio.setAttribute("x-webkit-airplay", "deny"); // Disable the iOS control center media widget
      _audio.preload = "auto";
      _audio.loop = true;
    } else {
      _audio.pause();
      _audio.removeAttribute("src");
    }

    _audio.src = silentAudioFile;
    _audio.load();

    _audio
      .play()
      .then(() => {
        console.log("unmuteIosAudio audio play success");
        cleanup();
      })
      .catch((e) => {
        _audio = null;
        console.error("unmuteIosAudio audio play error ", e);
      })
      .finally(() => {
        _isCreatingAudio = false;
      });
  }

  // function createWebAudio() {
  //   context = new AudioContext();

  //   source = context.createBufferSource();
  //   source.buffer = context.createBuffer(1, 1, 22050); // .045 msec of silence
  //   source.connect(context.destination);
  //   source.start();

  //   if (context.state === "running") {
  //     webAudioState = "allowed";
  //     maybeCleanup();
  //   } else {
  //     webAudioState = "blocked";

  //     source.disconnect(context.destination);
  //     source = null;

  //     context.close();
  //     context = null;
  //   }
  // }

  function cleanup() {
    USER_ACTIVATION_EVENTS.forEach((eventName) => {
      window.removeEventListener(eventName, handleUserActivation, {
        capture: true,
        passive: true,
      });
    });
  }
}
